import React, { ReactElement, useMemo } from 'react'

import AvatarLabel from '../../AvatarLabel'

export type ResidentCellProps = {
  avatarSize?: number
  onSelect?: () => void
  resident: {
    name?:
      | {
          first: string
          last: string
        }
      | string
    picture?: string
  }
  className?: string
}

export default function ResidentCell({
  avatarSize,
  onSelect,
  resident,
  className,
}: ResidentCellProps): ReactElement {
  const label = useMemo(() => {
    if (typeof resident.name === 'string') {
      return resident.name
    }
    return `${resident.name?.first} ${resident.name?.last}`
  }, [resident.name])

  return (
    <AvatarLabel
      className={className}
      label={label}
      onSelect={onSelect}
      picture={resident?.picture}
      avatarSize={avatarSize}
    />
  )
}
